// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding {
  max-width: 700px;
  padding: 1em;
  margin: 100px auto 0;

  h1 {
    font-size: 3.2em;
    margin-bottom: 1.5em;
  }
}

.onboardingSubtag {
  font-size: 1.7em;
  line-height: 1.2em;
}

.onboardingButtons {
  display: flex;
  gap: 0.4em;
  margin: 2em 0 3em;

  @media (max-width: 700px) {
    & {
      flex-direction: column;
    }
  }

  button, button:hover {
    opacity: 0;
    font-size: 1.1em;
    padding: 0.8em;
    animation: fadein 300ms ease-in forwards;
  }

  button:nth-child(2) { animation-delay: 200ms; }
  button:nth-child(3) { animation-delay: 400ms; }
}

.onboardingSecondary {
  background: transparent;
  border-color: transparent;
  color: var(--primary-color);
  font-weight: bold;

  &:is(:active, :hover) {
    color: var(--primary-color-hover);
  }
}

.onboardingImage {
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  animation: fadein 300ms ease-in forwards;
  opacity: 0;
  animation-delay: 600ms;

  img {
    width: 100%;
    height: auto;
  }
  div {
    padding: 1em;
  }

  & div:nth-child(1) {
    width: 85%;
    height: auto;
  }
  & div:nth-child(2) {
    position: absolute;
    width: 23%;
    height: auto;
    right: 4%;
    padding-top: 10%;
    top: 0;
  }
}

.onboardingSupport {
  max-width: 800px;
  margin: 5em auto 0;
  padding-bottom: 5em;
  line-height: 1.7em;

  h2 {
    margin-top: 1.5em;
    font-size: 2em;
  }
  p {
    font-size: 1.1em;
  }
}

.onboardingShadow {
  position: absolute;
  color: var(--accent-color);
  position: absolute;
  color: var(--accent-color);
  z-index: -1;
  margin-top: 3px;
  margin-left: 3px;
  pointer-events: none;
  user-select: none;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Onboarding.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;;EAEpB;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;;EAEjB;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,wCAAwC;EAC1C;;EAEA,sBAAsB,sBAAsB,EAAE;EAC9C,sBAAsB,sBAAsB,EAAE;AAChD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;;EAEjB;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,sBAAsB;;EAEtB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,MAAM;EACR;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".onboarding {\n  max-width: 700px;\n  padding: 1em;\n  margin: 100px auto 0;\n\n  h1 {\n    font-size: 3.2em;\n    margin-bottom: 1.5em;\n  }\n}\n\n.onboardingSubtag {\n  font-size: 1.7em;\n  line-height: 1.2em;\n}\n\n.onboardingButtons {\n  display: flex;\n  gap: 0.4em;\n  margin: 2em 0 3em;\n\n  @media (max-width: 700px) {\n    & {\n      flex-direction: column;\n    }\n  }\n\n  button, button:hover {\n    opacity: 0;\n    font-size: 1.1em;\n    padding: 0.8em;\n    animation: fadein 300ms ease-in forwards;\n  }\n\n  button:nth-child(2) { animation-delay: 200ms; }\n  button:nth-child(3) { animation-delay: 400ms; }\n}\n\n.onboardingSecondary {\n  background: transparent;\n  border-color: transparent;\n  color: var(--primary-color);\n  font-weight: bold;\n\n  &:is(:active, :hover) {\n    color: var(--primary-color-hover);\n  }\n}\n\n.onboardingImage {\n  max-width: 1600px;\n  margin: 0 auto;\n  position: relative;\n  animation: fadein 300ms ease-in forwards;\n  opacity: 0;\n  animation-delay: 600ms;\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n  div {\n    padding: 1em;\n  }\n\n  & div:nth-child(1) {\n    width: 85%;\n    height: auto;\n  }\n  & div:nth-child(2) {\n    position: absolute;\n    width: 23%;\n    height: auto;\n    right: 4%;\n    padding-top: 10%;\n    top: 0;\n  }\n}\n\n.onboardingSupport {\n  max-width: 800px;\n  margin: 5em auto 0;\n  padding-bottom: 5em;\n  line-height: 1.7em;\n\n  h2 {\n    margin-top: 1.5em;\n    font-size: 2em;\n  }\n  p {\n    font-size: 1.1em;\n  }\n}\n\n.onboardingShadow {\n  position: absolute;\n  color: var(--accent-color);\n  position: absolute;\n  color: var(--accent-color);\n  z-index: -1;\n  margin-top: 3px;\n  margin-left: 3px;\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
